import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  tab: {
    color: theme.palette.primary.main,
  },
}))

export default useStyles
